<template>
  <div :class="$attrs.class" :style="$attrs.style" class="form-group w-full">
    <ValidationProvider v-slot="{ errors }" :name="name" :rules="rules" v-bind="$attrs">
      <label v-if="label" :class="labelClass" class="block text-base font-normal mb-1">{{ label }}
        <b v-if="isRequired" class="ml-1 text-red-600 font-bold">*</b></label>
      <div class="relative input-group">
        <div v-if="leftIcon" class="icon-left"><i :class="leftIcon"></i></div>
        <input :class="['form-control', leftIcon ? 'pl-10' : '', rightIcon ? 'pr-10' : '', inputClass, value !== '' ? 'bg-white' : 'bg-gray-100']"
               :type="inputType"
               :value="value"
               autocomplete="off" v-bind="$attrs" @input="onChange" @keyup="onKeyUp">
        <div v-if="rightIcon" class="icon-right" @click="$emit('rightIconClick')"><i :class="rightIcon"></i></div>
        <div
            v-if="isPasswordType"
            class="icon-right cursor-pointer"
            :class="rightIcon ? 'mr-6' : ''"
            @click="togglePassword"
        >
          <i :class="showPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"></i>
        </div>
        <slot name="right-icon"></slot>
      </div>
      <span v-if="!!hint" :class="hintClass" class="text-xs text-gray-400">{{ hint }}</span>

      <span class="text-xs text-red-600">{{ errors[0] }}</span>
    </ValidationProvider>
  </div>
</template>

<script>
export default {
  name: "TextInput",
  props: {
    value: [String, Number],
    label: String,
    leftIcon: String,
    rightIcon: String,
    labelClass: [String, Array],
    inputClass: [String, Array],
    hintClass: [String, Array],
    rules: String,
    name: String,
    type: {
      type: String,
      default: "text"
    },
    hint: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      showPassword: false
    };
  },
  computed: {
    isRequired() {
      return this.required || this.rules?.search("required") > -1;
    },
    isPasswordType() {
      return this.type === "password";
    },
    inputType() {
      if (this.isPasswordType) {
        return this.showPassword ? "text" : "password";
      }
      return this.type;
    },
  },
  methods: {
    onChange(e) {
      let val = e.target.value;
      if (this.type === "number") {
        val = Number(val);
      }
      this.$emit("input", val);
    },
    onKeyUp(e) {
      let val = e.target.value;
      if (this.type === "number") {
        val = Number(val);
      }
      this.$emit("onKeyUp", val);
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    }
  },
}
</script>
